export const MockDataCompany = [
    {
        id: 1,
        razaoSocial: 'Empresa A',
        cnpj: '00.123.456/0001-01',
        estado: 'São Paulo'
    },
    {
        id: 2,
        razaoSocial: 'Empresa B',
        cnpj: '99.876.543/0001-02',
        estado: 'Rio de Janeiro'
    },
    {
        id: 3,
        razaoSocial: 'Empresa C',
        cnpj: '55.789.123/0001-03',
        estado: 'Minas Gerais'
    },
    {
        id: 4,
        razaoSocial: 'Empresa D',
        cnpj: '33.456.789/0001-04',
        estado: 'Bahia'
    },
    {
        id: 5,
        razaoSocial: 'Empresa E',
        cnpj: '88.654.321/0001-05',
        estado: 'Paraná'
    },
    {
        id: 6,
        razaoSocial: 'Empresa F',
        cnpj: '22.987.654/0001-06',
        estado: 'Rio Grande do Sul'
    },
    {
        id: 7,
        razaoSocial: 'Empresa G',
        cnpj: '11.321.654/0001-07',
        estado: 'Santa Catarina'
    },
    {
        id: 8,
        razaoSocial: 'Empresa H',
        cnpj: '66.456.789/0001-08',
        estado: 'Goiás'
    },
    {
        id: 9,
        razaoSocial: 'Empresa I',
        cnpj: '44.789.123/0001-09',
        estado: 'Ceará'
    },
    {
        id: 10,
        razaoSocial: 'Empresa J',
        cnpj: '77.258.369/0001-10',
        estado: 'Pernambuco'
    }
]

export const MockCompanyDescribe = [
    {
        id: 0,
        razaoSocial: 'Empresa A Ltda.',
        cnpj: '00.123.456/0001-01',
        nomeFantasia: 'Empresa A',
        matriz: 'Sim',
        situacaoCadastral: 'Ativa',
        dataSituacaoCadastral: '10/04/2024',
        dataInicioAtividade: '01/01/2010',
        naturezaJuridica: 'Sociedade Limitada',
        porte: 'Pequeno',
        secao: 'Indústria'
    },
    {
        id: 1,
        razaoSocial: 'Empresa B S/A',
        cnpj: '99.876.543/0001-02',
        nomeFantasia: 'Empresa B',
        matriz: 'Sim',
        situacaoCadastral: 'Ativa',
        dataSituacaoCadastral: '10/04/2024',
        dataInicioAtividade: '01/02/2005',
        naturezaJuridica: 'Sociedade Anônima Aberta',
        porte: 'Grande',
        secao: 'Comércio'
    },
    {
        id: 3,
        razaoSocial: 'Empresa C EIRELI',
        cnpj: '55.789.123/0001-03',
        nomeFantasia: 'Empresa C',
        matriz: 'Sim',
        situacaoCadastral: 'Ativa',
        dataSituacaoCadastral: '10/04/2024',
        dataInicioAtividade: '01/03/2012',
        naturezaJuridica: 'Empresa Individual de Responsabilidade Limitada',
        porte: 'Microempresa',
        secao: 'Serviços'
    },
    {
        id: 4,
        razaoSocial: 'Empresa D ME',
        cnpj: '33.456.789/0001-04',
        nomeFantasia: 'Empresa D',
        matriz: 'Sim',
        situacaoCadastral: 'Ativa',
        dataSituacaoCadastral: '10/04/2024',
        dataInicioAtividade: '01/04/2018',
        naturezaJuridica: 'Microempresa',
        porte: 'Microempresa',
        secao: 'Indústria'
    },
    {
        id: 5,
        razaoSocial: 'Empresa E Ltda.',
        cnpj: '88.654.321/0001-05',
        nomeFantasia: 'Empresa E',
        matriz: 'Sim',
        situacaoCadastral: 'Ativa',
        dataSituacaoCadastral: '10/04/2024',
        dataInicioAtividade: '01/05/2015',
        naturezaJuridica: 'Sociedade Limitada',
        porte: 'Pequeno',
        secao: 'Comércio'
    },
    {
        id: 6,
        razaoSocial: 'Empresa F S/A',
        cnpj: '22.987.654/0001-06',
        nomeFantasia: 'Empresa F',
        matriz: 'Sim',
        situacaoCadastral: 'Ativa',
        dataSituacaoCadastral: '10/04/2024',
        dataInicioAtividade: '01/06/2007',
        naturezaJuridica: 'Sociedade Anônima Aberta',
        porte: 'Grande',
        secao: 'Serviços'
    },
    {
        id: 7,
        razaoSocial: 'Empresa G MEI',
        cnpj: '11.321.654/0001-07',
        nomeFantasia: 'Empresa G',
        matriz: 'Sim',
        situacaoCadastral: 'Ativa',
        dataSituacaoCadastral: '10/04/2024',
        dataInicioAtividade: '01/07/2019',
        naturezaJuridica: 'Microempreendedor Individual (MEI)',
        porte: 'Microempresa',
        secao: 'Indústria'
    },
    {
        id: 8,
        razaoSocial: 'Empresa H EIRELI',
        cnpj: '66.456.789/0001-08',
        nomeFantasia: 'Empresa H',
        matriz: 'Sim',
        situacaoCadastral: 'Ativa',
        dataSituacaoCadastral: '10/04/2024',
        dataInicioAtividade: '01/08/2013',
        naturezaJuridica: 'Empresa Individual de Responsabilidade Limitada',
        porte: 'Pequeno',
        secao: 'Comércio'
    },
    {
        id: 9,
        razaoSocial: 'Empresa I Ltda.',
        cnpj: '44.789.123/0001-09',
        nomeFantasia: 'Empresa I',
        matriz: 'Sim',
        situacaoCadastral: 'Ativa',
        dataSituacaoCadastral: '10/04/2024',
        dataInicioAtividade: '01/09/2011',
        naturezaJuridica: 'Sociedade Limitada',
        porte: 'Médio',
        secao: 'Serviços'
    },
    {
        id: 10,
        razaoSocial: 'Empresa J S/A',
        cnpj: '77.258.369/0001-10',
        nomeFantasia: 'Empresa J',
        matriz: 'Sim',
        situacaoCadastral: 'Ativa',
        dataSituacaoCadastral: '10/04/2024',
        dataInicioAtividade: '01/10/2009',
        naturezaJuridica: 'Sociedade Anônima Aberta',
        porte: 'Grande',
        secao: 'Indústria'
    }
]

export const MockCompanyConts = [
    {
        id: 0,
        cpf: '04585573402',
        name: 'CECILIA NICODEMOS MARTINS BARROS',
        cnpj: '00.123.456/0001-01',
        crc: 5884,
        uf: 'PB'
    },
    {
        id: 1,
        cpf: '12345678900',
        name: 'João da Silva',
        cnpj: '99.876.543/0001-02',
        crc: 8456,
        uf: 'SP'
    },
    {
        id: 2,
        cpf: '98765432100',
        name: 'Maria Oliveira',
        cnpj: '55.789.123/0001-03',
        crc: 6325,
        uf: 'RJ'
    },
    {
        id: 3,
        cpf: '11223344556',
        name: 'Ana Silva',
        cnpj: '33.456.789/0001-04',
        crc: 7123,
        uf: 'MG'
    },
    {
        id: 4,
        cpf: '99887766554',
        name: 'Pedro Souza',
        cnpj: '88.654.321/0001-05',
        crc: 2584,
        uf: 'RS'
    },
    {
        id: 5,
        cpf: '76543210987',
        name: 'Carla Santos',
        cnpj: '22.987.654/0001-06',
        crc: 4597,
        uf: 'PR'
    },
    {
        id: 6,
        cpf: '88997766554',
        name: 'Luiz Oliveira',
        cnpj: '11.321.654/0001-07',
        crc: 8621,
        uf: 'BA'
    },
    {
        id: 7,
        cpf: '423546845654',
        name: 'Roberta Lima',
        cnpj: '66.456.789/0001-08',
        crc: 3214,
        uf: 'CE'
    },
    {
        id: 8,
        cpf: '423546845654',
        name: 'Maria Josafá',
        cnpj: '44.789.123/0001-09',
        crc: 9321,
        uf: 'CE'
    },
    {
        id: 9,
        cpf: '32156145321',
        name: 'João Josefa',
        cnpj: '77.258.369/0001-10',
        crc: 8712,
        uf: 'AM'
    },
]

export const CompanyAutos = [
    {
        id: 1,
        tipo: 'carro',
        owner: '00.123.456/0001-01',
        ano: '2015',
        marca: 'Toyota',
        modelo: 'Corolla',
        placa: 'ABC1234',
        situacao: 'regular'
    },
    {
        id: 2,
        tipo: 'moto',
        owner: '99.876.543/0001-02',
        ano: '2020',
        marca: 'Honda',
        modelo: 'CB 500',
        placa: 'XYZ5678',
        situacao: 'regular'
    },
    {
        id: 3,
        tipo: 'caminhão',
        owner: '55.789.123/0001-03',
        ano: '2012',
        marca: 'Volvo',
        modelo: 'FH460',
        placa: 'DEF9012',
        situacao: 'não-regular'
    },
    {
        id: 4,
        tipo: 'avião',
        owner: '33.456.789/0001-04',
        ano: '2008',
        marca: 'Boeing',
        modelo: '737',
        placa: 'GHI3456',
        situacao: 'regular'
    },
    {
        id: 5,
        tipo: 'carro',
        owner: '88.654.321/0001-05',
        ano: '2019',
        marca: 'Ford',
        modelo: 'Fiesta',
        placa: 'JKL6789',
        situacao: 'não-regular'
    },
    {
        id: 6,
        tipo: 'moto',
        owner: '22.987.654/0001-06',
        ano: '2017',
        marca: 'Yamaha',
        modelo: 'MT-09',
        placa: 'MNO0123',
        situacao: 'regular'
    },
    {
        id: 7,
        tipo: 'caminhão',
        owner: '11.321.654/0001-07',
        ano: '2010',
        marca: 'Mercedes-Benz',
        modelo: 'Actros',
        placa: 'PQR3456',
        situacao: 'não-regular'
    },
    {
        id: 8,
        tipo: 'avião',
        owner: '66.456.789/0001-08',
        ano: '2015',
        marca: 'Airbus',
        modelo: 'A320',
        placa: 'STU7890',
        situacao: 'regular'
    },
    {
        id: 9,
        tipo: 'carro',
        owner: '44.789.123/0001-09',
        ano: '2013',
        marca: 'Chevrolet',
        modelo: 'Cruze',
        placa: 'VWX9012',
        situacao: 'regular'
    },
    {
        id: 10,
        tipo: 'moto',
        owner: '77.258.369/0001-10',
        ano: '2016',
        marca: 'Suzuki',
        modelo: 'GSX-S750',
        placa: 'YZA2345',
        situacao: 'não-regular'
    }
]

export const CompanyOwner = [
    {
        id: '1',
        name: 'João da Silva',
        cpf: '123.456.789-00',
        companyOwner: '00.123.456/0001-01',
        dateIn: '01/01/2010',
        dateOut: '31/12/2020',
        vinculo: 'Sócio'
    },
    {
        id: '2',
        name: 'Maria Oliveira',
        cpf: '987.654.321-00',
        companyOwner: '00.123.456/0001-01',
        dateIn: '01/02/2005',
        dateOut: '30/11/2015',
        vinculo: 'Diretor'
    },
    {
        id: '3',
        name: 'José Santos',
        cpf: '246.813.579-00',
        companyOwner: '99.876.543/0001-02',
        dateIn: '01/03/2012',
        dateOut: '30/06/2018',
        vinculo: 'Acionista'
    },
    {
        id: '4',
        name: 'Ana Costa',
        cpf: '135.792.468-00',
        companyOwner: '55.789.123/0001-03',
        dateIn: '01/04/2018',
        dateOut: '31/12/2022',
        vinculo: 'Sócio'
    },
    {
        id: '5',
        name: 'Pedro Martins',
        cpf: '987.654.321-01',
        companyOwner: '33.456.789/0001-04',
        dateIn: '01/05/2015',
        dateOut: '30/09/2021',
        vinculo: 'Gerente'
    },
    {
        id: '6',
        name: 'Marta Pereira',
        cpf: '123.456.789-01',
        companyOwner: '88.654.321/0001-05',
        dateIn: '01/06/2007',
        dateOut: '31/08/2019',
        vinculo: 'Diretor'
    },
    {
        id: '7',
        name: 'Lucas Souza',
        cpf: '135.792.468-01',
        companyOwner: '22.987.654/0001-06',
        dateIn: '01/07/2019',
        dateOut: '30/11/2023',
        vinculo: 'Sócio'
    },
    {
        id: '8',
        name: 'Carla Lima',
        cpf: '246.813.579-01',
        companyOwner: '11.321.654/0001-07',
        dateIn: '01/08/2013',
        dateOut: '31/10/2020',
        vinculo: 'Acionista'
    },
    {
        id: '9',
        name: 'Rafaela Fernandes',
        cpf: '987.654.321-02',
        companyOwner: '66.456.789/0001-08',
        dateIn: '01/09/2011',
        dateOut: '30/06/2017',
        vinculo: 'Gerente'
    },
    {
        id: '10',
        name: 'Fernando Silva',
        cpf: '123.456.789-02',
        companyOwner: '44.789.123/0001-09',
        dateIn: '01/10/2009',
        dateOut: '31/12/2014',
        vinculo: 'Diretor'
    }
]

export const CompanyWorklist = [
    {
        id: 0,
        ano: '2022',
        vinculos: 150,
        folhaAnual: 'R$ 1.500.000,00',
        mediaSalarial: 'R$ 10.000,00',
        menorMediaSalarial: 'R$ 8.000,00',
        maiorMediaSalarial: 'R$ 12.000,00'
    },
    {
        id: 1,
        ano: '2023',
        vinculos: 160,
        folhaAnual: 'R$ 1.600.000,00',
        mediaSalarial: 'R$ 10.500,00',
        menorMediaSalarial: 'R$ 8.500,00',
        maiorMediaSalarial: 'R$ 12.500,00'
    },
    {
        id: 2,
        ano: '2024',
        vinculos: 170,
        folhaAnual: 'R$ 1.700.000,00',
        mediaSalarial: 'R$ 11.000,00',
        menorMediaSalarial: 'R$ 9.000,00',
        maiorMediaSalarial: 'R$ 13.000,00'
    },
    {
        id: 3,
        ano: '2025',
        vinculos: 180,
        folhaAnual: 'R$ 1.800.000,00',
        mediaSalarial: 'R$ 11.500,00',
        menorMediaSalarial: 'R$ 9.500,00',
        maiorMediaSalarial: 'R$ 13.500,00'
    },
    {
        id: 4,
        ano: '2026',
        vinculos: 190,
        folhaAnual: 'R$ 1.900.000,00',
        mediaSalarial: 'R$ 12.000,00',
        menorMediaSalarial: 'R$ 10.000,00',
        maiorMediaSalarial: 'R$ 14.000,00'
    },
    {
        id: 5,
        ano: '2027',
        vinculos: 200,
        folhaAnual: 'R$ 2.000.000,00',
        mediaSalarial: 'R$ 12.500,00',
        menorMediaSalarial: 'R$ 10.500,00',
        maiorMediaSalarial: 'R$ 14.500,00'
    },
    {
        id: 6,
        ano: '2028',
        vinculos: 210,
        folhaAnual: 'R$ 2.100.000,00',
        mediaSalarial: 'R$ 13.000,00',
        menorMediaSalarial: 'R$ 11.000,00',
        maiorMediaSalarial: 'R$ 15.000,00'
    },
    {
        id: 7,
        ano: '2029',
        vinculos: 220,
        folhaAnual: 'R$ 2.200.000,00',
        mediaSalarial: 'R$ 13.500,00',
        menorMediaSalarial: 'R$ 11.500,00',
        maiorMediaSalarial: 'R$ 15.500,00'
    },
    {
        id: 8,
        ano: '2030',
        vinculos: 230,
        folhaAnual: 'R$ 2.300.000,00',
        mediaSalarial: 'R$ 14.000,00',
        menorMediaSalarial: 'R$ 12.000,00',
        maiorMediaSalarial: 'R$ 16.000,00'
    },
    {
        id: 9,
        ano: '2031',
        vinculos: 240,
        folhaAnual: 'R$ 2.400.000,00',
        mediaSalarial: 'R$ 14.500,00',
        menorMediaSalarial: 'R$ 12.500,00',
        maiorMediaSalarial: 'R$ 16.500,00'
    }
]
